import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import { Mail, Users } from "lucide-react";
import CreateIndivialMessage from "../create/tabs/individual/create/create";
import CreateBulkMessage from "../create/tabs/bulk/create/create";

const QuickMessageLanding = () => {
  return (
    <div className="space-y-4 p-1">
      <PageHeader
        title="Quick Message"
        subtitle="Send individual or bulk messages across multiple channels"
      />
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden items-center gap-2">
          <Tabs
            defaultValue="indivialMessage"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
            urlMapping={{
              indivialMessage: "indivialMessage",
              bulkMessage: "bulkMessage",
            }}
            tabComponents={{
              indivialMessage: {
                label: "Individual Message",
                component: <CreateIndivialMessage />,
                icon: <Mail className="w-5 h-5" />,
              },
              bulkMessage: {
                label: "Bulk Message",
                component: <CreateBulkMessage />,
                icon: <Users className="w-5 h-5 mr-2" />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default QuickMessageLanding;
